/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';

import { from, tap } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';

import { environment } from '@environments/environment';

import { EncryptionService } from '@shared/services';
import { CaseContextService } from '@app/core/services/case-context/case-context.service';
import { TenantFacadeService } from '@shared/features/tenant/shared/services/tenant-facade.service';

declare const Calendly: any;

@Component({
  selector: 'app-schedule-appointment-calendar',
  template: `
    <section
      id="calendly-embed"
      class="flex-1 min-w-[420px] h-[480px]"></section>
  `,
  host: {
    '(window:message)': 'onCalendlyEvent($event)',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleAppointmentCalendarComponent implements OnInit {
  private readonly _dialogRef = inject(
    MatDialogRef<ScheduleAppointmentCalendarComponent>,
  );
  private readonly _caseContext = inject(CaseContextService);
  private readonly _tenantService = inject(TenantFacadeService);
  private readonly _encryptionService = inject(EncryptionService);

  ngOnInit(): void {
    const identifier: string = this._caseContext.uuid();
    const appType: string | undefined = this._tenantService.tenantApiPrefix();

    from(this._encryptionService.encrypt({ appType, identifier }))
      .pipe(tap((encrypted) => this.onInitCalendly(encrypted)))
      .subscribe();
  }

  private onInitCalendly(encrypted: string): void {
    Calendly.initInlineWidget({
      url: environment.calendly,
      parentElement: document.getElementById('calendly-embed'),
      utm: {
        utmContent: encrypted,
      },
    });
  }

  protected onCalendlyEvent(e: MessageEvent): void {
    if (!this.isCalendlyEvent(e)) return;

    switch (e.data.event) {
      case 'calendly.event_scheduled':
        this._dialogRef.close(true);
        break;
    }
  }

  private isCalendlyEvent(e: MessageEvent): boolean {
    return (
      e.origin === 'https://calendly.com' &&
      e.data?.event?.startsWith('calendly.')
    );
  }
}
